import React from 'react'
import moment from 'moment'
import { FormattedMessage } from 'react-intl'

export default ({info, role}) => {
	return (
		<div className='person-actual-v'>
			<div className='person-visits'>
                {(info.visitDates && (info.visitDates.person && info.visitDates.person.length > 0)) 
                    ? 
                    <div className='Visits visit-dates'>
                        <h1 className='Sidebar__head Sidebar__head_top visit-dates-title' > <FormattedMessage id={`visit_info_dates.${role}`}/> </h1>
                        <div className='visit-date-user' style={{marginTop: 0}}>
                            {info.visitDates.person.map((visit, i) => 
                                <div key={i} className='visit-date'>
                                    {moment(visit).add(3, 'hours').utc().format('DD.MM.YYYY HH:mm')}
                                </div>
                            )}
                        </div>
                        {(info.visitDates.user && info.visitDates.user.length > 0) &&
                            <div className='visit-date-user'>
                                <h2 className='visit-dates-title'> <FormattedMessage id={`visit_choosed_dates.${role}`}/> </h2>
                                {info.visitDates.user.map((visit, i) => 
                                    <span key={i} className='visit-date'>
                                        {moment(visit).add(3, 'hours').utc().format('DD.MM.YYYY HH:mm')}
                                    </span>
                                )}
                            </div>
                        }
                    </div>
                    :
                    <div style={{marginTop: '7.3206vw'}} className='Visits _noActualVisits'>Даты встречи еще не были выбраны</div>
                }
			</div>
		</div>
	)
}


// WEBPACK FOOTER //
// ./src/components/Profile/SidebarVisits.jsx